import { NavLink } from "react-router-dom";

const NoData= () => {
  return (
    <section className="flex flex-col items-center justify-center h-screen  w-full">
      <div className="text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-4">Sorry! Data is Not Found</h2>
       
        <NavLink
          to="/"
          className="px-6 py-2 bg-blue-600 text-white text-lg font-semibold rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50"
        >
          Return to Login Page
        </NavLink>
      </div>
    </section>
  );
};

export default NoData;